'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { ImagesHeroSectionStoryblok, RichtextStoryblok } from '@qogita/cms'
import { cn } from '@qogita/ui/utils/cn'
import { useAuthentication } from 'src/core/authentication/provider'
import { render } from 'storyblok-rich-text-react-renderer'

import { CmsSectionErrorBoundary } from '../cms-section-error-boundary'
import { CtaContained, CtaWhite } from '../components/cta'
import { StoryblokImage } from '../components/storyblok-image'

export function ImagesHeroSection(props: { blok: ImagesHeroSectionStoryblok }) {
  const Comp = props.blok.variant === 'one' ? V1 : V2
  return (
    <CmsSectionErrorBoundary>
      <Comp blok={props.blok} />
    </CmsSectionErrorBoundary>
  )
}

function V1({ blok }: { blok: ImagesHeroSectionStoryblok }) {
  const cta = useGetCta(blok)

  return (
    <section
      className={cn([
        'font-outfit overflow-hidden md:h-[506px]',
        getThemeClass(blok.theme),
      ])}
    >
      <div className="relative mx-auto grid h-full max-w-6xl grid-cols-1 justify-items-center py-16 md:grid-cols-3 md:justify-items-normal md:gap-2 md:py-0">
        <div>
          {blok.image1 ? (
            <StoryblokImage
              src={blok.image1.filename}
              width={206}
              height={259}
              alt={blok.image1.alt || blok.image1.name}
              className="relative top-0 left-0"
            />
          ) : null}

          {blok.image2 ? (
            <StoryblokImage
              src={blok.image2.filename}
              width={168}
              height={211}
              alt={blok.image2.alt || blok.image2.name}
              className="relative -top-5 left-15"
            />
          ) : null}
        </div>

        <div className="flex max-w-96 flex-col items-center justify-center gap-8">
          {renderHeader(blok.heading, blok.theme)}
          {cta.link ? <CtaWhite link={cta.link}>{cta.label}</CtaWhite> : null}
        </div>

        <div className="hidden md:block">
          {blok.image3 ? (
            <StoryblokImage
              src={blok.image3.filename}
              width={242}
              height={182}
              alt={blok.image3.alt || blok.image3.name}
              className="relative top-15 justify-self-end-safe"
            />
          ) : null}

          {blok.image4 ? (
            <StoryblokImage
              src={blok.image4.filename}
              width={140}
              height={180}
              alt={blok.image4.alt || blok.image4.name}
              className="relative top-20 left-15"
            />
          ) : null}
        </div>
      </div>
    </section>
  )
}

function V2({ blok }: { blok: ImagesHeroSectionStoryblok }) {
  const cta = useGetCta(blok)

  return (
    <section
      className={cn([
        'overflow-hidden md:h-[506px]',
        getThemeClass(blok.theme),
      ])}
    >
      <div className="relative mx-auto grid h-full max-w-6xl grid-cols-1 justify-items-center gap-2 py-16 md:grid-cols-3 md:justify-items-normal md:py-0">
        <div className="relative order-1 flex flex-col justify-start md:pr-14 lg:pr-0">
          {blok.image1 ? (
            <StoryblokImage
              src={blok.image1.filename}
              width={254}
              height={319}
              alt={blok.image1.alt || blok.image1.name}
              className="top-0 left-0"
            />
          ) : null}

          {blok.image2 ? (
            <StoryblokImage
              src={blok.image2.filename}
              width={168}
              height={211}
              alt={blok.image2.alt || blok.image2.name}
              className="relative -top-30 right-[10%] hidden self-end-safe md:block"
            />
          ) : null}
        </div>

        <div className="z-10 order-3 -mt-[50px] flex max-w-80 flex-col items-center justify-center gap-8 self-center justify-self-center md:order-2">
          {renderHeader(blok.heading, blok.theme)}
          {blok.theme === 'lavender' ? (
            cta.link ? (
              <CtaContained link={cta.link}>{cta.label}</CtaContained>
            ) : null
          ) : cta.link ? (
            <CtaWhite link={cta.link}>{cta.label}</CtaWhite>
          ) : null}
        </div>

        {blok.image3 ? (
          <StoryblokImage
            src={blok.image3.filename}
            height={138}
            width={203}
            alt={blok.image3.alt || blok.image3.name}
            className="relative -top-25 left-20 order-2 object-cover md:top-10 md:right-0 md:left-0 md:order-3 md:h-[229px] md:w-[338px] md:justify-self-end-safe md:pl-14 lg:pl-0"
          />
        ) : null}
      </div>
    </section>
  )
}

function useGetCta(blok: ImagesHeroSectionStoryblok) {
  const { isAuthenticated } = useAuthentication()

  const cta =
    isAuthenticated && blok.authenticatedCtaLink && blok.authenticatedCtaLink
      ? {
          label: blok.authenticatedCtaLabel,
          link: blok.authenticatedCtaLink,
        }
      : {
          label: blok.anonymousCtaLabel,
          link: blok.anonymousCtaLink,
        }

  return cta
}
function renderHeader(
  richTextDocument: RichtextStoryblok | RichtextStoryblok[] | undefined,
  theme: ImagesHeroSectionStoryblok['theme'],
) {
  return render(richTextDocument, {
    nodeResolvers: {
      paragraph: (children) => (
        <h3
          className={cn(
            'font-figtree text-center text-3xl font-normal text-pretty',
            theme === 'lavender' ? 'text-gray-800' : 'text-gray-200',
          )}
        >
          {children}
        </h3>
      ),
    },
  })
}

function getThemeClass(theme: ImagesHeroSectionStoryblok['theme']) {
  switch (theme) {
    case 'blue':
      return 'bg-marketing-navy'
    case 'red':
      return 'bg-marketing-burgundy'
    case 'lavender':
      return 'bg-marketing-lavender'
    default:
      return 'bg-gray-100'
  }
}
